import Http from "./base-http";

class OvertimeRule extends Http {

  deleteOvertimeRule(id) {
    return this.destroy(id);
  }
}

const overtimeRuleObj = new OvertimeRule({
  modelUrlPrefix : "overtimeRule"
});

export default overtimeRuleObj;